import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import axiosInstance from '@/axiosInstance'; 

export const fetchShipping = createAsyncThunk(
  'shipping/fetchShipping',
  async (_, {   }) => {
    try {
      const response = await axiosInstance.get('/api/website/shipping'); 
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || 'Something went wrong');
    }
  }
);


const shippingSlice = createSlice({
    name: "shipping",
    initialState: {
      shipping: [],
      loading: false,
      error: null,
    },
    reducers: {},
    extraReducers: (builder) => {
      builder
        .addCase(fetchShipping.pending, (state) => {
          state.loading = true;
          state.error = null;
        })
        .addCase(fetchShipping.fulfilled, (state, action) => {
          state.loading = false;
          state.shipping = action.payload;
        })
        .addCase(fetchShipping.rejected, (state, action) => {
          state.loading = false;
          state.error = action.payload;
        });
    }}
);

export default shippingSlice.reducer;